import { render } from "./COIListItem.vue?vue&type=template&id=4a1ebc4a"
import script from "./COIListItem.vue?vue&type=script&lang=js"
export * from "./COIListItem.vue?vue&type=script&lang=js"

import "./COIListItem.vue?vue&type=style&index=0&id=4a1ebc4a&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__